<template>
  <v-dialog
    content-class="dialog-custom"
    v-model="dialog"
    persistent
    max-width="max-content"
  >
      <v-card light style="padding-top: 16px; padding-bottom: 16px">
             <div style = "position: absolute; right: 0;">
            <v-btn
              v-if="isTransactionStatus !== 'success'"
              class="mx-2"
              icon
              title="Close Form"
              @click="handleDialogClose"
            >
              <v-icon dark>
                fas fa-times
              </v-icon>
            </v-btn>
          </div>
      <v-card-title style=" word-break: normal">
        <div style = "position: relative;" class="dialog-header-custom">
        <div>
        <div class="netTitle">
          <div v-if="isTransactionStatus === 'success'" class="icon">
            <img src="/img/paymentSuccess.png" alt="Payment Successful" />
          </div>
          <div v-else-if="isTransactionStatus === 'failed'" class="icon">
            <img src="/img/paymentFailed.png" alt="Payment Successful" />
          </div>
          <div class="transactionMessage">{{ transactionMessage }}</div>
        </div>
        <div class="white-box plan-selection__plan text-black">
          <ul class="choose-plan">
            <li class="choose-plan_list choose-plan__item">
              <span class="choose-plan__item--paymentType">Transaction ID</span>
              <span class="choose-plan__item--text darken">{{
                paymentTransactionId
              }}</span>
            </li>
            <li class="choose-plan_list choose-plan__item">
              <span class="choose-plan__item--paymentType">Amount</span>
              <div class="choose-plan__item--text darken">
                <div class="amountBreakdown">
                  &#x20B9;{{ (transactionAmount) | localeAmount }} +
                  &#x20B9;{{ charges }}
                </div>
              </div>
            </li>
            <li class="choose-plan_list choose-plan__item">
              <span class="choose-plan__item--paymentType">Date/Time</span>
              <span class="choose-plan__item--text darken">{{
                transactionDate
              }}</span>
            </li>
            <li
              class="choose-plan_list choose-plan__item"
              v-if="isTransactionStatus === 'success'"
            >
              <span class="bold"
                >Your funds will take upto 72 hours to reflect in your
                investment account.</span
              >
            </li>
            <li
              class="choose-plan__item"
              v-if="isTransactionStatus === 'failed'"
            >
              <span class="bold"
                >Your transaction has failed. Please try again!.</span>
            </li>
          </ul>
        </div>
        <div
          style="text-align: center"
          class="register__form--referral-bottom"
        >
          <button v-if="isTransactionStatus === 'success'" style="max-width: 343px; border-radius: 8px; background-color: #002FA7; color: #FFFFFF; border: 2px solid #FFFFFF" class="btn btn-secondary w-100 mt-15 mb-15" @click="successTransaction">
            Continue to dashboard
          </button>
        </div>
      </div>
        </div>
      </v-card-title>
    </v-card>
  </v-dialog>
</template>

<script>
import OnboardingService from '@/services/lenderOnboardingService.js'
export default {
    name: 'paymentDialog',
    components: {
    },
    props: {
        showPayUDialog: Boolean
    },
    data () {
        return {
            dialog: this.showPayUDialog,
            queries: this.$route.query,
            isTransactionStatus: true,
            transactionMessage: 'Payment Successful',
            paymentTransactionId: '',
            transactionAmount: null,
            charges: 0,
            transactionDate: ''
        }
    },
    mounted () {
        this.queryHandler()
    },
    methods: {
        queryHandler () {
            if (this.queries) {
                if (Object.keys(this.queries).length) {
                    if (this.queries.status === 'success') {
                        this.isTransactionStatus = 'success'
                        this.transactionMessage = 'Payment Successful'
                    } else {
                        this.isTransactionStatus = 'failed'
                        this.transactionMessage = 'Payment Failed'
                    }
                    this.paymentTransactionId = this.queries.txnid
                    this.transactionDate = this.queries.addedon
                    if (this.queries.mode === 'payu-NB') {
                        this.mode = 'netOne'
                        this.charges = 15 + 0.18 * 15
                    } else if (this.queries.mode === 'payu-UPI') {
                        this.mode = 'netTwo'
                        this.charges = 2 + 0.18 * 2
                    } else {
                        this.charges = 0
                    }
                    this.transactionAmount = this.queries.amount
                }
            }
        },
        handleDialogClose () {
            this.$emit('closeDialog')
        },
        successTransaction () {
            this.facebookConversion()
            this.handleDialogClose()
        },
        facebookConversion () {
            const payload = {}
            payload.EventName = 'purchase'
            OnboardingService.facebookConversionAPI(payload).then(async (res) => {})
        }
    }
}
</script>
<style lang="scss" scoped>
@import "~@/sass/components/registration-flow.scss";
@import "@/components/dashboard/dashboard.scss";
.v-card__title {
  line-height: 24px
}
.choose-plan__item--paymentType {
    font-size: 16px
}
.choose-plan__item--text darken {
    font-size: 14px
}
.bold {
    padding-top: 8px;
    font-size: 18px;
    color: #4f4f4f
}
.payment-methods {
  display: block;
  .paymentMethodsWrapper {
    display: flex;
    justify-content: space-between;
  }

  &__content {
    border: 1px solid $light-grey;
    padding: 10px;
    position: relative;
    margin: 10px;
    flex-basis: 150px;
    flex-grow: 1;
    h2 {
      font-size: $h4-font-size;
      font-weight: $font-weight-medium;
    }
    .fa-chevron-right {
      position: absolute;
      right: 20px;
      color: $primary;
      top: 50%;
      transform: translateY(-50%);
    }
    .fa-rupee-sign {
      font-size: $font-size-xxs;
      position: relative;
      top: -2px;
      color: $black;
    }
  }

  &__pay-info {
    @include flex(flex, center, flex-start);
    span {
      margin-right: 15px;
      font-size: $font-size-md;
      font-weight: $font-weight-normal;
      i {
        position: relative;
        top: -1px;
        margin-right: 5px;
        color: $black;
      }
    }
  }
}
.white-box.disabled {
  background-color: rgb(241, 239, 239);
  cursor: unset !important;
  color: #666e75;
}
.white-box {
  cursor: pointer !important;
}
.v-application p {
  margin-bottom: 0px;
}
.netTitle {
  display: flex;
  flex-direction: column;
  align-items: center;

  .icon img {
    width: 60px;
    height: 60px;
  }

  .transactionMessage {
    padding-bottom: 24px;
    font-size: 24px;
    font-weight: 600;
  }
}
.activeMethod {
  background-color: $primary !important;

  h2,
  p,
  span {
    color: $white !important;
  }

  .v-icon.v-icon {
    color: $white !important;
  }
}
.amount {
  font-size: 18px;
  font-weight: 550 !important;
  letter-spacing: 2px;
}
.forhove {
  &:hover {
    background: linear-gradient(
      90.19deg,
      #0b1133 6.62%,
      #071a90 99.86%
    ) !important;

    h2,
    p,
    span {
      color: $white !important;
    }

    .v-icon.v-icon {
      color: $white !important;
    }
  }
}
.register__form {
  min-width: 600px !important;
}
@media (max-width: 990px) {
  .white-box,
  .px-50 {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  .paymentMethods .white-box {
    padding-left: 32px !important;
    padding-right: 32px !important;
  }

  .dashboard__leftpanel {
    display: none;
  }

  .payment-methods form .paymentMethodsWrapper {
    display: block !important;
  }

  .payment-methods .payment-methods__content {
    border: 1px solid $light-grey;
    padding: 10px;
    margin-top: 12px;
    height: unset;
  }

  .register__form {
    min-width: unset !important;
  }
}
.amountBreakdown {
  display: flex;
  justify-content: space-between;
}
.v-icon.v-icon {
  font-size: 24px;
}
.dialog-custom {
  background: #ffffff;
  border: 1px solid #b9b9bb !important;
  box-sizing: border-box !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
  border-radius: 20px !important;

  .v-card__actions {
    padding: 20px !important;
  }
}

.v-text-field .v-label {
  font-weight: bold !important;
}
.dialog-header-custom {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
}

.custom-btn-common {
  width: 150px;
  font-size: 14px;
  text-transform: none;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 22px;
}

.custom-btn {
  background-color: #ffcb05 !important;
  font-size: 14px;
  text-transform: none;

  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 22px;

  .v-icon {
    font-size: 14px;
    margin-left: 16px;
  }

  @media (max-width: 525px) {
    .choose-plan_list {
      display: grid !important
  }
}
.choose-plan_list {
  display: flex !important
}
}
</style>
